import { HeatMapChart } from '@/components/composite/Charts/HeatMapChart';
import { SIZE_FULL } from '@/lib/gridElements/size';
import { percentFormat } from '@/hooks/format/useFormatNumber';

export const bestTimeToPostConfig = {
    minWidth: 750,
    name: {
        day: {
            views: 'chart.best_time_to_post.video_views_more',
            likes: 'chart.best_time_to_post.likes_more',
            engagement: 'chart.best_time_to_post.engagement_more'
        },
        value: {
            views: 'chart.best_time_to_post.video_views_less',
            likes: 'chart.best_time_to_post.likes_less',
            engagement: 'chart.best_time_to_post.engagement_less'
        }
    },
    noTableView: true,
    csv: true,
    id: 'best_time_to_post',
    color: {
        value: 'white'
    },
    colors: {
        light: {
            blue200: '#96D8FF',
            blue300: '#33a1ff',
            blue400: '#1a95ff',
            blue: '#0089ff'
        },
        dark: {
            blue200: '#11263F',
            blue300: '#0E3861',
            blue400: '#085BA5',
            blue: '#0089ff'
        }
    },
    legendType: 'bttp',
    tooltipTranslation: {
        filtersToken: {
            views: 'chart.youtube.best_time_to_post_views_tooltip_chart',
            likes: 'chart.youtube.best_time_to_post_likes_tooltip_chart',
            engagement: 'chart.youtube.best_time_to_post_engagement_tooltip_chart'
        },
        values: ['date', 'day', 'value', 'count_posts']
    },
    valueFormat: {
        views: {},
        likes: {},
        engagement: { ...percentFormat, maximumFractionDigits: 5 }
    },
    legendHighlightValueTranslation: {
        filtersToken: {
            views: 'chart.youtube.best_time_to_post_views_legend_highlight',
            likes: 'chart.youtube.best_time_to_post_likes_legend_highlight',
            engagement: 'chart.youtube.best_time_to_post_engagement_legend_highlight'
        },
        values: ['date', 'day']
    },
    tooltip: 'chart.youtube.tooltip_best_time_to_post_views',
    size: SIZE_FULL,
    type: 'chart',
    iconHighestValue: 'star',
    margin: { bottom: 10, left: -30 },
    breakpoints: [
        { color: 'blue200', r: 3.5 },
        { color: 'blue300', r: 7.5 },
        { color: 'blue400', r: 12.5 },
        { color: 'blue', r: 12.5 }
    ],
    defaultFilter: 'views',
    filters: {
        views: {
            title: 'chart.youtube.best_time_to_post_views',
            menu: 'chart.youtube.best_time_to_post_filter_views'
        },
        likes: {
            title: 'chart.youtube.best_time_to_post_likes',
            menu: 'chart.youtube.best_time_to_post_filter_likes'
        }
    },
    element: HeatMapChart
};
